<template>
  <li class="boss-jobtype-item">
    <label class="boss-label pega-input"><input
      v-model="all"
      type="checkbox"
      class="boss-input-check"
    >{{ category.name }}</label>
    <ul
      class="boss-jobtype-details"
      data-test="category-items"
    >
      <select-modal-contents-category-item
        v-for="(categoryItem, index) in category.children"
        :key="index"
        :category-item="categoryItem"
        :category-item-data-map="categoryDataMap[categoryItem.id]"
        :experience-range-options="experienceRangeOptions"
        :default-experience-id="defaultExperienceId"
        @update-category-item="updateCategoryItem"
      />
    </ul>
  </li>
</template>

<script>
import SelectModalContentsCategoryItem from '@/components/molecules/SelectModalContentsCategoryItem'

export default {
  components: {
    SelectModalContentsCategoryItem
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    categoryDataMap: {
      type: Object,
      required: true
    },
    experienceRangeOptions: {
      type: Array,
      default: () => ([])
    },
    defaultExperienceId: {
      type: String,
      default: ''
    }
  },
  computed: {
    all: {
      get () {
        return this.category.children.every(j => this.categoryDataMap[j.id].check)
      },
      set (value) {
        this.updateCategoryChecks(value)
      }
    }
  },
  methods: {
    updateCategoryItem (data) {
      this.$emit('update-category', { id: this.category.id, value: { ...this.categoryDataMap, [data.id]: data.value } })
    },
    updateCategoryChecks (value) {
      // data[CategoriesId][categoryId]のcheckを全て置き換える
      this.$emit('update-category', {
        id: this.category.id,
        value: this.category.children.reduce((acc, j) => (
          { ...acc, [j.id]: { ...this.categoryDataMap[j.id], check: value } }
        ), {})
      })
    }
  }
}
</script>
